var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex all-after-header-box"},[_c('div',{staticClass:"content-box marg-l-10"},[_vm._v(" Main Page ")])])
}]

export { render, staticRenderFns }